import { LitElement, html, nothing } from 'lit';

export default class FloatCountryProvince extends LitElement {
  createRenderRoot() {
    return this;
  }

  static get properties() {
    return {
      countries: { type: Array, state: true },
      provinces: { type: Array, state: true },
      customer: { type: Object, state: true },
      required: { type: Boolean, state: true },
    };
  }

  constructor() {
    super();
    this.countries = Object.values(window.countryProvinceData);
    this.provinces = this.countries[0]?.provinces;
  }

  connectedCallback() {
    super.connectedCallback();

    if (!window.countryProvinceData) {
      document.addEventListener('float-country-province:ready', (event) => {
        this.countries = event.detail;
        this.provinces = this.countries[0].provinces;
      });
    } else {
      this.countries = Object.values(window.countryProvinceData);
      this.provinces = this.countries[0]?.provinces;
    }

    if (!this.countries && !this.countries.length) return;
  }

  matchCountry(country) {
    const downcasedCountry = country?.name?.toLowerCase();
    const downcasedCustomerCountry = this.customer?.country?.toLowerCase();

    const downcaseMatch = downcasedCountry === downcasedCustomerCountry;

    return downcaseMatch;
  }

  render() {
    if (!this.countries || !this.countries.length) return nothing;

    return html`
      <div class="form_split_elements">
        <float-country
          name="country"
          label="Country/region of residence"
          id="country"
          ?required=${this.required}
          error="Please select your country"
          value=${this.customer?.country || ''}
          .options=${[
        {
          label: 'Country/region of residence',
          value: '',
          disabled: true,
          hidden: true,
          selected: !this.customer?.country,
        },
        ...this.countries.map((country) => ({
          label: country.name,
          value: country.name,
          selected: this.matchCountry(country),
        })),
      ]}
        ></float-country>

        <float-province
          name="province"
          label="Province"
          ?required=${this.required}
          id="province"
          error="Please select your province"
          value=${this.customer?.province || ''}
          customer-province=${this.customer?.province || ''}
          .options=${[
        {
          label: 'Province',
          value: '',
          disabled: true,
          hidden: true,
          selected: this.customer?.province ?? true,
        },
        this.provinces.map((province) => ({
          label: province,
          value: province,
          selected:
            this.customer?.province === province,
        })),
      ]}
        ></float-province>
      </div>
    `;
  }
}

window.customElements.get('float-country-province') ||
  window.customElements.define('float-country-province', FloatCountryProvince);
